// @givmo/app-charity — claim-flow route paths (CPA-WEB2).
//
// Single source of truth for the claim destinations so the route tree (routes.tsx), the nav shell
// (app-shell.tsx), and the pages' `navigate({ to })` calls all agree. Kept as plain string constants
// (not TanStack route objects) to avoid an import cycle with the route tree.

export const CLAIM_ROUTES = {
  /** Org search — the claim entry point. */
  search: '/claim',
  /** Claim wizard for a selected charity (`:charityId`). */
  wizard: '/claim/$charityId',
  /** The caller's claim requests list. */
  claims: '/claims',
  /** A single claim's status + Tier-2 document upload (`:claimRequestId`). */
  claimDetail: '/claims/$claimRequestId',
} as const;

/** Build the wizard path for a concrete charity id. */
export function wizardPath(charityId: string): string {
  return `/claim/${charityId}`;
}

/** Build the claim-detail path for a concrete claim-request id. */
export function claimDetailPath(claimRequestId: string): string {
  return `/claims/${claimRequestId}`;
}
